/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormField, {
  FormCheckboxFieldProps
} from '../../../../client/js/components/form/fields/FormField'
import { parseBoolean } from '@jalik/form-parser'
import { Checkbox } from '@mantine/core'

function PublishedField (props: FormCheckboxFieldProps) {
  const { name = 'published', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'published',
        defaultMessage: 'Publié'
      })}
      name={name}
      parser={parseBoolean}
      render={Checkbox}
      type="checkbox"
      value="true"
      {...others}
    />
  )
}

export default PublishedField
